// src/components/StatCard.js
import React from 'react';

export default function StatCard({ label, value, sub, color = '#b8862e', icon }) {
  // `color` is a free-form runtime accent → exposed to CSS via a custom property.
  return (
    <div className="stat-card" style={{ '--accent': color }}>
      <div className="stat-card__top">
        <div>
          <div className="stat-card__value">{value ?? '—'}</div>
          <div className="stat-card__label">{label}</div>
        </div>
        <div className="stat-card__icon" style={{ background: color + '18' }}>{icon}</div>
      </div>
      {sub && <div className="stat-card__sub">{sub}</div>}
    </div>
  );
}
